import React from "react";
import { Star, ShieldCheck, TrendingUp } from "lucide-react";
import { RESULTS, GUARANTEE } from "../mock";
import { useReveal } from "../hooks/useReveal";

function initials(name) {
  return name
    .replace(/&/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

export default function Results() {
  const r = useReveal();
  return (
    <section id="results" className="bg-ls-alt py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">Real results, real contractors</p>
        <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl max-w-4xl mb-5">
          Booked jobs. <span className="text-orange">Not reports.</span>
        </h2>
        <p className="text-lg text-[#c7bdae] max-w-3xl mb-12">
          Home service pros using the system. Real outcomes, real companies.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {RESULTS.map((c, i) => (
            <div key={i} className="card-dark p-6 flex flex-col">
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-orange" fill="#f26a21" />
                ))}
              </div>
              <div className="flex items-center gap-2 mb-3">
                <TrendingUp className="w-4 h-4 text-orange shrink-0" />
                <span className="font-cond font-bold text-white uppercase tracking-wide text-[15px] leading-tight">
                  {c.outcome}
                </span>
              </div>
              <p className="text-[#d7cdbf] leading-relaxed flex-1">&ldquo;{c.quote}&rdquo;</p>
              <div className="mt-5 pt-4 border-t flex items-center gap-3" style={{ borderColor: "var(--ls-border)" }}>
                <span
                  className="flex items-center justify-center w-10 h-10 rounded-full font-cond font-bold text-[#0a0f16] shrink-0"
                  style={{ backgroundColor: "var(--ls-orange)" }}
                >
                  {initials(c.name)}
                </span>
                <div>
                  <div className="text-white font-semibold text-sm leading-tight">{c.name} · {c.company}</div>
                  <div className="text-xs text-[#9a8f80] uppercase tracking-wide">{c.trade}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Guarantee */}
        <div
          className="mt-8 rounded-2xl p-7 md:p-9 flex flex-col md:flex-row items-start md:items-center gap-5"
          style={{ background: "var(--ls-surface)", border: "1px solid rgba(242,106,33,0.5)" }}
        >
          <span
            className="flex items-center justify-center w-14 h-14 rounded-full shrink-0"
            style={{ backgroundColor: "rgba(242,106,33,0.12)" }}
          >
            <ShieldCheck className="w-7 h-7 text-orange" />
          </span>
          <div className="flex-1">
            <h3 className="font-cond font-extrabold text-2xl text-white uppercase tracking-wide">{GUARANTEE.title}</h3>
            <p className="text-[#c7bdae] mt-1 leading-relaxed">{GUARANTEE.body}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
